import { getRoundedNumber } from '../getRoundedNumber/getRoundedNumber';

type FeetInches = {
  feet: number;
  inches: number;
  value: string;
};

export const getFeetInchesFromInches = (inches: number): FeetInches => {
  const feet = Math.floor(inches / 12);
  const remainingInches = getRoundedNumber(inches % 12, 2);
  const value = remainingInches ? `${feet}ft ${remainingInches}in` : `${feet}ft`;

  return { feet, inches: remainingInches, value };
};
